import { ReactElement } from 'react';
import { useTheme, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  header: string;
  greyOutHeader: string;
  expanded: boolean;
  onClick: () => void;
  'data-testid'?: string;
  children: ReactElement;
}

export function ResultsPanelAccordion({ header, greyOutHeader, expanded, onClick, 'data-testid': testId, children }: Props): ReactElement {
  const theme = useTheme();

  return (
    <Accordion
      elevation={0}
      disableGutters
      expanded={expanded}
      sx={{
        borderTop: `1px solid #D3D3D3`,
        '&.MuiAccordion-root:before': {
          height: '0px',
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={onClick} data-testid={testId}>
        <Typography>{header}</Typography>
        <Typography sx={{ marginLeft: '6px', color: theme.palette.grey[500] }}>{greyOutHeader}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '16px', paddingTop: '0px' }}>{children}</AccordionDetails>
    </Accordion>
  );
}
